(function () {
    "use strict";

    angular.module("app").controller("LibraryEntriesController", lController);

    function lController($scope,$rootScope, $state,LibraryService, BrandService, SeasonService, toaster,SearchFactory, cfpLoadingBar ) {
        var model = this;

        model.brands = [];
        model.seasons = [];      

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
             $scope.userpermissionflag = $rootScope.userPermissions
            if (userPermissionRow[0] === 9) {
                if (userPermissionRow[1] === 2) {
                    model.LibraryCreate = true;
                }
            }
        });

        if (!model.LibraryCreate) {
            $state.go("permissionDenied");
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        model.brandChanged = function () {
            if (!model.selectedBrand) {
                return;
            } else {
                if (model.selectedBrand.BrandId == 15) {
                    model.NewLastDescr = 'WCG LAST';
                } else {
                    model.NewLastDescr = model.selectedBrand.BrandName + ' LAST';
                }
            }

            model.searchExisting();
        };

        model.searchExisting = function () {
            if (model.startModalSearch && (!model.isBrandRequired || model.selectedBrand)) {
                $scope.modalSearch = model.startModalSearch(model.selectedBrand);
                $scope.modalSearch.startSearch(true, null, true);
            }
        };

        model.showSaveButton = function () {
            if (!$scope.modalSearch || !$scope.modalSearch.searchResults) {
                return false;
            }
            return _.some($scope.modalSearch.searchResults, function (item) {
                return item.markedForDeletion === true;
            });
        }

        model.saveEdits = function () {
            if (!$scope.modalSearch || !$scope.modalSearch.searchResults || !model.selectedType || !model.selectedType.deleteFunc)
                return;

            var markedForDeletions = _.filter($scope.modalSearch.searchResults, function (item) {
                return item.markedForDeletion === true;
            });
            model.selectedType.deleteFunc(markedForDeletions);
        }

        model.deleteDevelopers = function (devRoleId) {
            return function (developers) {
                var ids = _.map(developers, function (i) { return i.DeveloperId });

                LibraryService.deleteDevelopers({
                    brandId: model.selectedBrand.BrandId,
                    roleId: devRoleId,
                    developerIds: ids
                }).then(function (data) {
                        showSuccess(data, ids.length + " " + model.selectedType.TypeName + "(s) successfully deleted.");
                },
                    showFailure);

                $scope.modalSearch.search(true);
            }
        }

        model.deleteDevelopmentCenters = function (developmentCenters) {
            _.forEach(developmentCenters, function (vm) {
                LibraryService.updateDevelopmentCenter({
                    DevelopmentCenterId: vm.DevelopmentCenterId,
                    DevelopmentCenterKey: vm.DevelopmentCenterKey,
                    DevelopmentCenterName: vm.DevelopmentCenterName,
                    isActive: false
                }).then(function (data) { showSuccess(data, vm.DevelopmentCenterName + " successfully deleted."); }, showFailure)
            });
            
        }

        model.typeChanged = function () {
            $scope.libraryEditForm.$setPristine();

            $scope.modalSearch = null;

            model.searchExisting();
        };

        model.searchExisting = function () {
            if (model.selectedType && (!model.selectedType.hasBrand || model.selectedBrand)) {
                $scope.modalSearch = model.selectedType.startModalSearch(model.selectedBrand);
                $scope.modalSearch.startSearch(true, null, true);
            }
        };

        model.addDeveloper = function (devRoleId) {
            LibraryService.addDeveloper({
                brandId: model.selectedBrand.BrandId,
                roleId: devRoleId,
                firstName: model.selectedType.fields[0].value,
                lastName: model.selectedType.fields[1].value
            }).then(showSuccess, showFailure);
        };

        model.createLibraryEntry = function (formInvalid) {
            if (!formInvalid) {
                model.selectedType.save();
            } else {
                model.disableSave = false;
            }
        };

        function showSuccess(data, msg) {
            if (data && data.IsSuccessful === false) {
                showFailure(data.Message);
                return;
            }

            model.searchExisting();

            $scope.libraryEditForm.$setPristine();
            $scope.libraryEditForm.$setUntouched();

            toaster.pop({ type: "success", title: "Success!", body: msg || "Item added successfully.", timeout: 5000 });

            clearForms();
            model.disableSave = false;
        }

        function clearForms() {
            model.NRFID = null;
            model.nrfColor = null;
            model.patternDesc = null;
            for (var f in model.selectedType.fields) {
                model.selectedType.fields[f].value = "";
            }
        }

        function showFailure(error) {
            toaster.pop({
                type: "error",
                title: "Error!",
                body: error,
                timeout: 10000
            });
            model.disableSave = false;
        }

        function showExtend(msg, title, onYes) {
            model.QuestionText = msg;
            model.QuestionTitle = title;
            model.QuestionYes = onYes;
            $("#questionModal").modal("show");
            model.disableSave = false;
        }

        function initView() {
            /*BrandService.getBrandsByUser().then(function (data) {
                model.brands = data;
            });

            SeasonService.getSeasons().then(function (data) {
                model.seasons = data;
            });*/

            model.libraryTypes = [
                {
                    TypeName: "Outsole",
                    hasBrand: true,
                    hasSeason: true,
                    fields: [
                        { label: "Outsole Name", value: "" },
                        { label: "Price", value: "" }
                    ],
                    save: function () {
                        var data = {
                            BrandId: model.selectedBrand.SAPBrandId,
                            OutsoleName: model.selectedType.fields[0].value,
                            SeasonId: model.selectedSeason.SeasonId,
                            Price: model.selectedType.fields[1].value,
                            ExtendBrand: false
                        };

                        LibraryService.addOutsole(data).then(function (response) {
                            model.extendBrand = false;
                            if (response.IsSuccessful) {
                                if (response.Data.ExtendBrand) {
                                    showExtend("Extend Brand", "Outsole already exists. Do you want to extend to " + model.selectedBrand.BrandName + " / " + model.selectedSeason.Description + "?", function () {
                                        data.ExtendBrand = true;
                                        LibraryService.addOutsole(data).then(showSuccess, showFailure);
                                    });
                                } else {
                                    clearForms();
                                    showSuccess();
                                }
                            } else {
                                showFailure(response.Message);
                            }
                        }, showFailure);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.outsoleSearch(brand.SAPBrandId, function () { });
                    }
                },
                {
                    TypeName: "Midsole",
                    hasBrand: true,
                    hasSeason: true,
                    fields: [
                        { label: "Midsole Name", value: "" },
                        { label: "Price", value: "" }
                    ],
                    save: function () {
                        var data = {
                            BrandId: model.selectedBrand.SAPBrandId,
                            MidsoleName: model.selectedType.fields[0].value,
                            SeasonId: model.selectedSeason.SeasonId,
                            Price: model.selectedType.fields[1].value,
                            ExtendBrand: model.extendBrand
                        };
                        LibraryService.addMidsole(data).then(function (response) {
                            model.extendBrand = false;
                            if (response.IsSuccessful) {
                                if (response.Data.ExtendBrand) {
                                    showExtend("Extend Brand", "Outsole already exists. Do you want to extend to " + model.selectedBrand.BrandName + " / " + model.selectedSeason.Description + "?", function () {
                                        data.ExtendBrand = true;
                                        LibraryService.addMidsole(data).then(showSuccess, showFailure);
                                    });
                                } else {
                                    clearForms();
                                    showSuccess();
                                }
                            } else {
                                showFailure(response.Message);
                            }
                        }, showFailure);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.midsoleSearch(brand.SAPBrandId, function () { });
                    }
                },
                {
                    TypeName: "Last",
                    hasLast: true,
                    hasBrand: true,
                    fields: [
                        { label: "Last Name", value: "" },
                        //{ label: "Last Name Description", value: "", disabled: true } //handled in html
                    ],
                    save: function () {
                        var data = {
                            brandId: model.selectedBrand.BrandId,
                            lastDesc: model.selectedBrand.BrandId === 15 ? "WCG LAST" : model.selectedBrand.BrandName + " LAST",
                            lastName: model.selectedType.fields[0].value
                        };
                        LibraryService.lastExists(data.lastName, model.selectedBrand.BrandId).then(function (response) {
                            if (response.existsInBrand) {
                                showFailure("Last already exists for " + model.selectedBrand.BrandName);
                                $scope.libraryEditForm.lastName.$touched = true;
                            } else if (response.lastNameExists) {
                                showExtend("Last already exists. Do you want to extend to " + model.selectedBrand.BrandName + "?", "Extend Last", function () {
                                    data.extend = true;
                                    LibraryService.addLast(data).then(showSuccess, showFailure);
                                });
                            } else {
                                LibraryService.addLast(data).then(showSuccess, showFailure);
                            }
                        });
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.lastSearch(brand.BrandId, function () { });
                    }
                },
                {
                    TypeName: "Pattern Description",
                    fields: [
                        { label: "Pattern Description", value: "" }
                    ],
                    save: function () {
                        var data = {
                            PatternDesc: model.selectedType.fields[0].value
                        };
                        LibraryService.addPatternDesc(data).then(showSuccess, showFailure);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.patternDescriptionSearch(function () { });
                    }
                },
                {
                    TypeName: "Pattern Name",
                    hasPatternName: true,
                    fields: [
                        { label: "Pattern Name", value: "" },
                        //{ label: "Pattern Description", value: "" } //located in HTML with search help directive
                    ],
                    save: function () {
                        setTimeout( function () { //Added a timeout function to wait until the pattern description search help had time to validate if the user typed a value (on blur).  No way do i really want to do this, but it seems to work for now.
                            var data = {
                                PatternName: model.selectedType.fields[0].value,
                                PatternDesc: model.patternDesc
                            };
                            LibraryService.addPattern(data).then(showSuccess, showFailure);
                        }
                        , 300);
                        
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.patternNameSearch(function () { });
                    }
                },
                {
                    TypeName: "Color",
                    hasNrfColor: true,
                    fields: [
                        { label: "Color Name", value: "" }
                    ],
                    save: function () {
                        var data = {
                            ColorDesc: model.selectedType.fields[0].value,
                            NRFID: model.NRFID
                        };
                        LibraryService.addColor(data).then(showSuccess, showFailure);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.basicColorSearch(function () { });
                    }
                },
                {
                    TypeName: "Cutting Pattern",
                    fields: [
                        { label: "Cutting Pattern", value: "" }
                    ],
                    save: function () {
                        var data = {
                            CuttingPattern: model.selectedType.fields[0].value
                        };
                        LibraryService.addCuttingPattern(data).then(showSuccess, showFailure);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.cuttingPatternSearch(function () { });
                    }
                },
                {
                    TypeName: "Development Center",
                    fields: [
                        { label: "Development Center Key", value: "" },
                        { label: "Development Center Name", value: "" }
                    ],
                    save: function () {
                        var data = {
                            DevelopmentCenterKey: model.selectedType.fields[0].value,
                            DevelopmentCenterName: model.selectedType.fields[1].value
                        };
                        LibraryService.addDevelopmentCenter(data).then(showSuccess, showFailure);
                    },
                    update: function (item) {
                        LibraryService.updateDevelopmentCenter({
                            DevelopmentCenterId: item.DevelopmentCenterId,
                            DevelopmentCenterKey: item.edit["DevelopmentCenterKey"],
                            DevelopmentCenterName: item.edit["DevelopmentCenterName"],
                            isActive: true
                        }).then(function (data) { showSuccess(data, item.DevelopmentCenterName + " successfully updated.") }, showFailure);
                    },
                    canDelete: true,
                    deleteFunc: model.deleteDevelopmentCenters,
                    canEdit: true,
                    startModalSearch: function () {
                        return SearchFactory.developmentCenterSearch(function () { });
                    }
                },
                {
                    TypeName: "Designer",
                    hasBrand: true,
                    fields: [
                        { label: "First Name", value: "" },
                        { label: "Last Name", value: "" }
                    ],
                    save: function () {
                        model.addDeveloper(1);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.developerSearch(brand.BrandId, 1, function () { });
                    },
                    canDelete: true,
                    deleteFunc: model.deleteDevelopers(1)
                },
                {
                    TypeName: "Developer",
                    hasBrand: true,
                    fields: [
                        { label: "First Name", value: "" },
                        { label: "Last Name", value: "" }
                    ],
                    save: function () {
                        model.addDeveloper(2);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.developerSearch(brand.BrandId, 2, function () { });
                    },
                    canDelete: true,
                    deleteFunc: model.deleteDevelopers(2)
                },
                {
                    TypeName: "Sourcing Developer",
                    hasBrand: true,
                    fields: [
                        { label: "First Name", value: "" },
                        { label: "Last Name", value: "" }
                    ],
                    save: function () {
                        model.addDeveloper(3);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.developerSearch(brand.BrandId, 3, function () { });
                    },
                    canDelete: true,
                    deleteFunc: model.deleteDevelopers(3)
                },
                {
                    TypeName: "Contract Designer",
                    hasBrand: true,
                    fields: [
                        { label: "First Name", value: "" },
                        { label: "Last Name", value: "" }
                    ],
                    save: function () {
                        model.addDeveloper(4);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.developerSearch(brand.BrandId, 4, function () { });
                    },
                    canDelete: true,
                    deleteFunc: model.deleteDevelopers(4)
                },
                {
                    TypeName: "Colorist",
                    hasBrand: true,
                    fields: [
                        { label: "First Name", value: "" },
                        { label: "Last Name", value: "" }
                    ],
                    save: function () {
                        model.addDeveloper(5);
                    },
                    startModalSearch: function (brand) {
                        return SearchFactory.developerSearch(brand.BrandId, 5, function () { });
                    },
                    canDelete: true,
                    deleteFunc: model.deleteDevelopers(5)
                }
            ];
        }

        initView();

        $("#actions").click(function (event) {
            var el = $(".sticky-box");
            if (el.css("display") === "block") {
                el.css("display", "none");
            } else {
                el.css("display", "block");
            }
            event.stopPropagation();
        });
    }
})();
